import React from 'react'

import HomeCardRecipe from './HomeCardRecipe';
import RecipeCategories from '../Recipe/RecipeCategories';

function Home() {
    return (
        <>
            <HomeCardRecipe/>
            <RecipeCategories/>
            
        </>
    )
}
export default Home